import React from 'react'
import iconSuccess from '../../../assets/icons/email/icon-success.png'
import logoPudo from '../../../assets/icons/logo-pudo-en-tu-camino.png'
import iconFacebook from '../../../assets/icons/email/icon-facebook.png'
import iconInstagram from '../../../assets/icons/email/icon-instagram.png'
import iconX from '../../../assets/icons/email/icon-x.png'
import { strings } from '../../../localization/strings'

var DEFAULT_COLOR = '#f7b500'
var HEADER_HEIGHT = 80
var ENDUSER_RESERVATION_ALIAS = 'ABC123'
var LOCKER_NAME = 'Carrefour Versalles'
var LOCKER_ADDRESS = 'Av. Álvarez Jonte 6383 - C1408 - CABA'
const emailStrings = strings.configNotificationTemplateEmail

var EmailPreview = function ({ logo, brandColor }) {
    var templateLogo  = logo       || logoPudo
    var templateColor = brandColor || DEFAULT_COLOR

    return (
        <div
            style={{
                fontFamily: 'Arial, Helvetica, sans-serif',
                background: '#e8e8e8',
                padding: '30px 10px',
                boxSizing: 'border-box',
                width: '100%',
            }}
        >
            <div
                style={{
                    maxWidth: 600,
                    width: '100%',
                    margin: '0 auto',
                    background: '#ffffff',
                    borderRadius: 4,
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                }}
            >
                <div
                    style={{
                        background: templateColor,
                        height: HEADER_HEIGHT,
                        padding: '0 40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxSizing: 'border-box',
                    }}
                >
                    <img
                        src={templateLogo}
                        alt="Logo"
                        style={{
                            display: 'block',
                            maxHeight: HEADER_HEIGHT - 20,
                            maxWidth: '100%',
                            width: 'auto',
                            height: 'auto',
                            border: 0,
                            outline: 'none',
                        }}
                    />
                </div>
                <div
                    style={{
                        background: '#ffffff',
                        padding: '25px 40px 30px 40px',
                        textAlign: 'center',
                        boxSizing: 'border-box',
                    }}
                >
                    <div style={{ paddingBottom: 20 }}>
                        <img
                            src={iconSuccess}
                            alt="Ícono de éxito"
                            width={50}
                            height={50}
                            style={{ display: 'block', margin: '0 auto', border: 0, outline: 'none' }}
                        />
                    </div>
                    <div style={{ paddingBottom: 34 }}>
                        <p style={{ margin: 0, fontSize: 19, fontWeight: 'bold', color: '#222222', fontFamily: 'Arial, Helvetica, sans-serif' }}>
                            {emailStrings.reservationConfirmedTitle}
                        </p>
                    </div>
                    <div style={{ paddingBottom: 20 }}>
                        <p style={{ margin: 0, fontSize: 15, color: '#222222', fontFamily: 'Arial, Helvetica, sans-serif' }}>
                            {emailStrings.reservationConfirmedPrefix}{' '}
                            <strong style={{ color: '#222222' }}>
                                {ENDUSER_RESERVATION_ALIAS}
                            </strong>{' '}
                            {emailStrings.reservationConfirmedSuffix}
                        </p>
                    </div>
                    <div style={{ paddingBottom: 20 }}>
                        <p style={{ margin: 0, fontSize: 15, color: '#222222', fontFamily: 'Arial, Helvetica, sans-serif' }}>
                            {emailStrings.selectedLockerLabel}
                        </p>
                    </div>
                    <div style={{ paddingBottom: 12 }}>
                        <p style={{ margin: 0, fontSize: 14, fontWeight: 'bold', color: '#222222', fontFamily: 'Arial, Helvetica, sans-serif' }}>
                            {LOCKER_NAME}
                        </p>
                    </div>
                    <div style={{ paddingBottom: 15 }}>
                        <p style={{ margin: 0, fontSize: 14, color: '#222222', fontFamily: 'Arial, Helvetica, sans-serif' }}>
                            {LOCKER_ADDRESS}
                        </p>
                    </div>
                </div>
                <div style={{ borderTop: '1px solid #c4c4c4', fontSize: 0, lineHeight: 0 }} />
                <div
                    style={{
                        background: '#f9f9f9',
                        padding: '20px 40px 18px 40px',
                        textAlign: 'center',
                        boxSizing: 'border-box',
                    }}
                >
                    <div style={{ paddingBottom: 10 }}>
                        <p style={{ margin: 0, fontSize: 13, color: '#353535', fontFamily: 'Arial, Helvetica, sans-serif' }}>
                            {emailStrings.thankYouForUseSmartLockers}
                        </p>
                    </div>
                    <div style={{ paddingBottom: 10 }}>
                        <img
                            src={logoPudo}
                            alt="Pudo - En Tu Camino"
                            style={{ display: 'block', margin: '0 auto', maxWidth: 100, height: 'auto', border: 0, outline: 'none' }}
                        />
                    </div>
                    <div style={{ paddingBottom: 2 }}>
                        <p style={{ margin: 0, fontSize: 12, color: '#353535', fontFamily: 'Arial, Helvetica, sans-serif' }}>
                            {emailStrings.contactUsMessage}
                        </p>
                    </div>
                    <div style={{ paddingBottom: 2 }}>
                        <a
                            href="mailto:info.ar@pudolatam.com"
                            style={{ color: '#2B6CB0', fontSize: 12, textDecoration: 'underline', fontFamily: 'Arial, Helvetica, sans-serif' }}
                        >
                            info.ar@pudolatam.com
                        </a>
                    </div>
                    <div style={{ paddingBottom: 12 }}>
                        <a
                            href="https://www.pudo.com.ar"
                            style={{ color: '#2B6CB0', fontSize: 12, textDecoration: 'underline', fontFamily: 'Arial, Helvetica, sans-serif' }}
                        >
                            www.pudo.com.ar
                        </a>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <a href="https://www.facebook.com/pudo.ar" style={{ textDecoration: 'none', padding: 8, display: 'block' }}>
                            <img src={iconFacebook} alt="Facebook" width={20} style={{ display: 'block', border: 0, outline: 'none' }} />
                        </a>
                        <a href="https://www.instagram.com/pudoar" style={{ textDecoration: 'none', padding: 8, display: 'block' }}>
                            <img src={iconInstagram} alt="Instagram" width={20} style={{ display: 'block', border: 0, outline: 'none' }} />
                        </a>
                        <a href="https://www.x.com/PudoAr" style={{ textDecoration: 'none', padding: 8, display: 'block' }}>
                            <img src={iconX} alt="X" width={20} style={{ display: 'block', border: 0, outline: 'none' }} />
                        </a>
                    </div>
                </div>
                <div
                    style={{
                        background: '#e8e8e8',
                        padding: '10px 40px 20px 40px',
                        textAlign: 'center',
                        boxSizing: 'border-box',
                    }}
                >
                    <p style={{ margin: 0, fontSize: 12, color: '#AEB7B8', lineHeight: 1.6, fontFamily: 'Arial, Helvetica, sans-serif' }}>
                        {emailStrings.emailNotificationsDisclaimer}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default EmailPreview